import * as React from 'react'
import { cn } from '../../lib/cn'

/**
 * DataTableToolbar — slotted layout for search + filters + actions above a table.
 * Composition-friendly: pass SearchBar, FilterPill row, Button row as children.
 */
export interface DataTableToolbarProps extends React.HTMLAttributes<HTMLDivElement> {
  search?: React.ReactNode
  filters?: React.ReactNode
  actions?: React.ReactNode
}

export const DataTableToolbar = React.forwardRef<HTMLDivElement, DataTableToolbarProps>(
  ({ className, search, filters, actions, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('flex items-center justify-between gap-4 py-3', className)}
      {...props}
    >
      <div className="flex items-center gap-3 flex-1 min-w-0">
        {search && <div className="w-[320px] max-w-full">{search}</div>}
        {filters && <div className="flex items-center gap-1 flex-wrap">{filters}</div>}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
  ),
)
DataTableToolbar.displayName = 'DataTableToolbar'
